export const INPUT_FIELD_ERROR_CLASSNAME = 'bg-destructive-foreground border-destructive'
export const LARGE_INPUT_FIELD_CLASSNAME = 'w-[400px] bg-foreground text-primary'
export const INPUT_FIELD_CLASSNAME = 'w-full flex h-10 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-btn-secondary disabled:text-secondary'

export enum CredentialsClassname {
  ACTIVE = `group bg-foreground h-[190px] w-[203px] rounded-md flex flex-col 
    items-center justify-end p-6 mr-6 mb-6 hover:cursor-pointer hover:border-2 hover:border-accent
    hover:bg-accent-background duration-100`,
  COMING_SOON = `bg-border h-[190px] w-[203px] rounded-md flex flex-col 
    items-center justify-end p-6 mr-6 mb-6`,
  ACTIVE_APP_NAME = `mt-6 font-semibold text-primary h-12 flex flex-row items-center 
    group-hover:text-accent group-hover:underline`,
  COMING_SOON_APP_NAME = `mt-6 font-semibold text-secondary h-12 flex flex-row items-center 
    group-hover:text-accent group-hover:underline`
}

export enum WorkflowRunType {
  PARENT = `group rounded-md border-2 flex flex-col items-start p-5 mb-5 hover:cursor-pointer 
     hover:border-2 hover:border-accent hover:bg-accent-background duration-100`,
  PARENT_SELECTED = `border-accent bg-accent-background`,
  PARENT_NOT_SELECTED = `bg-foreground border-foreground`,
  TITLE = `mb-1 font-semibold text-primary flex flex-row items-center 
    group-hover:text-accent`,
  SUBTITLE = 'text-primary font-normal text-sm leading-4'
}

export enum AppTile {
  ACTIVE = `group bg-foreground h-[140px] w-[153px] rounded-md flex flex-col 
    items-center justify-end p-4 mr-4 mb-4 hover:cursor-pointer hover:border-2 hover:border-accent
    hover:bg-accent-background duration-100`,
  COMING_SOON = `bg-border h-[140px] w-[153px] rounded-md flex flex-col 
    items-center justify-end p-4 mr-4 mb-4`,
  ACTIVE_APP_NAME = `mt-4 font-semibold text-primary text-sm h-8 flex flex-row items-center 
    group-hover:text-accent group-hover:underline`,
  COMING_SOON_APP_NAME = `mt-4 font-semibold text-secondary text-sm h-8 flex flex-row items-center 
    group-hover:text-accent group-hover:underline`
}
